import { render, staticRenderFns } from "./ZSliderTick.vue?vue&type=template&id=196165e4&"
import script from "./ZSliderTick.vue?vue&type=script&lang=js&"
export * from "./ZSliderTick.vue?vue&type=script&lang=js&"
import style0 from "./ZSliderTick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports